const ArrowForward = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M12.0214 16.5658C11.863 16.5658 11.7047 16.5074 11.5797 16.3824C11.338 16.1408 11.338 15.7408 11.5797 15.4991L16.1964 10.8824L11.5797 6.26576C11.338 6.02409 11.338 5.62409 11.5797 5.38242C11.8214 5.14076 12.2214 5.14076 12.463 5.38242L17.5214 10.4408C17.763 10.6824 17.763 11.0824 17.5214 11.3241L12.463 16.3824C12.338 16.5074 12.1797 16.5658 12.0214 16.5658Z"
                fill="white"
            />
            <path
                d="M16.9391 11.5078H2.91406C2.5724 11.5078 2.28906 11.2245 2.28906 10.8828C2.28906 10.5411 2.5724 10.2578 2.91406 10.2578H16.9391C17.2807 10.2578 17.5641 10.5411 17.5641 10.8828C17.5641 11.2245 17.2807 11.5078 16.9391 11.5078Z"
                fill="white"
            />
        </svg>
    );
};

export default ArrowForward;
